export default __webpack_public_path__ + "images/KL.893a40c.png";